import { Component, Vue } from "vue-property-decorator";

import template from "./authLayout.vue";

/**
 * AuthLayout
 */
@Component({
  mixins: [template],
})
export default class AuthLayout extends Vue {
}
